import axios from 'axios';
import {
  baseURL,
  base_log_url,
  base_star_url,
  base_star_plan_url,
  base_act_url,
  base_login_url,
} from './baseURL';
import {
  requestBefore,
  requestFail,
  responseBefore,
  responseFail,
  requestJavaBefore,
  actRequestBefore,
} from './interceptors';

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
const actInstance = axios.create({
  baseURL: base_act_url,
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log('base_login_url', base_login_url);
const loginInstance = axios.create({
  baseURL: base_login_url,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});
const instance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});
//创建激励数据请求实例
const mstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
//创建打点请求实例
const logInstance = axios.create({
  baseURL: base_log_url,
  headers: {
    'Content-type': 'text/plain',
  },
});
//获取星启计划内容
const starInstance = axios.create({
  baseURL: base_star_url,
  headers: {
    'Content-Type': 'application/json',
  },
});
//星启计划时长激励参与
const starPlanInstance = axios.create({
  baseURL: base_star_plan_url,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
// 设置默认超时时间 - 60s。
instance.defaults.timeout = 60000;

// 添加请求拦截器
loginInstance.interceptors.request.use(requestBefore, requestFail);
instance.interceptors.request.use(requestBefore, requestFail);
mstance.interceptors.request.use(requestBefore, requestFail);
//starPlanInstance.interceptors.request.use(requestBefore, requestFail);
// 添加响应拦截器
loginInstance.interceptors.response.use(responseBefore, responseFail);
instance.interceptors.response.use(responseBefore, responseFail);
actInstance.interceptors.response.use(responseBefore, responseFail);

// 设置默认超时时间 - 60s。
axiosInstance.defaults.timeout = 60000;

// 添加请求拦截器
axiosInstance.interceptors.request.use(requestBefore, requestFail);

// 添加响应拦截器
axiosInstance.interceptors.response.use(responseBefore, responseFail);

//添加请求拦截器
starPlanInstance.interceptors.request.use(requestJavaBefore, requestFail);
//添加请求拦截器
actInstance.interceptors.request.use(actRequestBefore, requestFail);
//添加请求拦截器
//logInstance.interceptors.request.use(requestBefore, requestFail);

//starInstance.interceptors.request.use(requestBefore, requestFail);
// 添加响应拦截器
// logInstance.interceptors.response.use(responseBefore, responseFail);
export {
  instance,
  axiosInstance,
  logInstance,
  starInstance,
  mstance,
  starPlanInstance,
  actInstance,
  loginInstance,
};
